export const API_DATE_FORMAT = 'yyyy-MM-dd'

export const DATA_DATE_FORMAT = 'dd.MM.yyyy HH:mm:ss'

export const SHORT_DATA_DATE_FORMAT = 'dd.MM.yyyy'

export const DISPLAY_DATE_FORMAT = 'dd.MM.yyyy HH:mm'
